export enum SupplierNation {
    ITALY = 'italy',
    EU_COUNTRY = 'eu',
    EXTRA_EU_COUNTRY = 'extra-eu',
}
